import { FormattedMessage } from 'react-intl';

import { Error } from '~/components/error/error';

const LinkExpiredPage = () => (
  <Error>
    <Error.Heading>
      <FormattedMessage id="onboarding-payee.error.linkExpired.title" />
    </Error.Heading>
    <Error.Description id="onboarding-payee.error.linkExpired.description" />
  </Error>
);

export default LinkExpiredPage;
